import "./scss/landingPage.scss";

const LandingPage = () => {
  return <div className="landing-container">Landing Page</div>;
};

export default LandingPage;
